import { NAVIGATION_NAME } from "interfaces/Navigation";

import { SessionsSideBar } from "./session/SessionSideBar";

type Props = {
  currentSection: NAVIGATION_NAME;
};

const SIDE_BAR_COMPONENTS: { [k in NAVIGATION_NAME]: JSX.Element } = {
  Inicio: <></>,
  Dashboard: <></>,
  Dispositivos: <></>,
  Sesiones: <SessionsSideBar />,
  Puntajes: <></>,
  Partidas: <></>,
  Usuarios: <></>,
  Configuraciones: <></>,
  Vinculaciones: <></>,
  Documentación: <></>,
};

export const SideBar = ({ currentSection }: Props) => {
  return (
    <div className="relative flex flex-col flex-1">
      {SIDE_BAR_COMPONENTS[currentSection]}
    </div>
  );
};
